import { keyframes, styled } from '../../lib/stitches'
import { gray3 } from '../platform/color'

const skeletonAnimation = keyframes({
  '0%': { opacity: 1 },
  '50%': { opacity: 0.3 },
  '100%': { opacity: 1 }
})

const Skeleton = styled('div', {
  borderRadius: '6px',
  background: gray3,
  boxSizing: 'border-box',
  animation: `linear 2s infinite ${skeletonAnimation}`
})

export default Skeleton
